import api from './http';

// Users & Roles
export const getUsers = () => api.get('/users');
export const getUser = (id) => api.get(`/users/${id}`);
export const updateUserRole = (id, data) => api.patch(`/users/${id}/role`, data);
export const createUser = (data) => api.post('/users/create', data);
export const getRoles = () => api.get('/roles');
export const updateRolePermissions = (roleName, data) => api.patch(`/roles/${roleName}`, data);

// Signature utilisateur
export const saveSignature = (data) => api.post('/users/me/signature', data);
export const getSignature = () => api.get('/users/me/signature');
export const deleteSignature = () => api.delete('/users/me/signature');

// Activity logs
export const getActivityLogs = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.module) qs.append('module', params.module);
  if (params.user_id) qs.append('user_id', params.user_id);
  if (params.action) qs.append('action', params.action);
  if (params.limit) qs.append('limit', params.limit);
  if (params.skip) qs.append('skip', params.skip);
  return api.get(`/activity/logs?${qs.toString()}`);
};
export const getActivityStats = () => api.get('/activity/stats');

// Custom Fields
export const getCustomFields = (appliesTo = 'contacts') => api.get(`/custom-fields?applies_to=${appliesTo}`);
export const createCustomField = (data) => api.post('/custom-fields', data);
export const updateCustomField = (id, data) => api.patch(`/custom-fields/${id}`, data);
export const deleteCustomField = (id) => api.delete(`/custom-fields/${id}`);

// CRM Orgs (Multi-Organization)
export const getCrmOrgs = () => api.get('/crm-orgs');
export const getCurrentCrmOrg = () => api.get('/crm-orgs/current');
export const createCrmOrg = (data) => api.post('/crm-orgs', data);
export const updateCrmOrg = (id, data) => api.patch(`/crm-orgs/${id}`, data);
export const getCrmOrgMembers = (orgId) => api.get(`/crm-orgs/${orgId}/members`);
export const addCrmOrgMember = (orgId, data) => api.post(`/crm-orgs/${orgId}/members`, data);
export const updateCrmOrgMember = (orgId, userId, data) => api.patch(`/crm-orgs/${orgId}/members/${userId}`, data);
export const getConsolidatedStats = () => api.get('/crm-orgs/consolidated/stats');

// Scheduler
export const getSchedulerStatus = () => api.get('/scheduler/status');
export const updateSchedulerConfig = (config) => api.patch('/scheduler/config', config);
export const getSchedulerLogs = (limit = 20) => api.get(`/scheduler/logs?limit=${limit}`);

// Search
export const globalSearch = (q, module = 'all') => api.get(`/search?q=${encodeURIComponent(q)}&module=${module}`);
export const advancedSearch = (params) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== '') qs.append(k, v); });
  return api.get(`/search/advanced?${qs.toString()}`);
};
export const getSavedFilters = () => api.get('/search/filters');
export const saveFilter = (data) => api.post('/search/filters', data);
export const deleteSavedFilter = (id) => api.delete(`/search/filters/${id}`);

// Universal Key status
export const getUniversalKeyStatus = () => api.get('/universal-key/status');

// Automations & Notifications
export const runAutomations = () => api.post('/automations/run');
export const getNotifications = (unreadOnly = false, limit = 50) => api.get(`/notifications?unread_only=${unreadOnly}&limit=${limit}`);
export const markNotificationRead = (id) => api.patch(`/notifications/${id}/read`);
export const markAllNotificationsRead = () => api.post('/notifications/read-all');
export const getNotificationsCount = () => api.get('/notifications/count');
export const getWsStatus = () => api.get('/notifications/ws-status');

// Workflows
export const listWorkflows = () => api.get('/workflows');
export const getWorkflow = (id) => api.get(`/workflows/${id}`);
export const createWorkflow = (data) => api.post('/workflows', data);
export const updateWorkflow = (id, data) => api.put(`/workflows/${id}`, data);
export const deleteWorkflow = (id) => api.delete(`/workflows/${id}`);
export const toggleWorkflow = (id) => api.post(`/workflows/${id}/toggle`);
export const testWorkflow = (id) => api.post(`/workflows/${id}/test`);
export const getWorkflowHistory = (id) => api.get(`/workflows/${id}/history`);
export const getRecentExecutions = () => api.get('/workflows/executions/recent');
export const getWorkflowTemplates = () => api.get('/workflows/templates');
export const getWorkflowSchema = () => api.get('/workflows/schema');
